import { Component } from '@angular/core';
import { TermsComponent } from "../terms.component";

@Component({
    selector: 'app-terms-page',
    imports: [TermsComponent],
    templateUrl: './terms-page.component.html',
    styleUrl: './terms-page.component.scss'
})
export class TermsPageComponent {

}
